export enum EAppcuesType {
  BANNER = 'banner',
  FLOW = 'flow',
}
